// extracted by mini-css-extract-plugin
module.exports = {"box":"announcement_box_3-KZV","content":"announcement_content_27KtD","wrap":"announcement_wrap_1q11T"};